<template>
  <div id="powerbi-wrapper">
    <div class="vx-row">
      <div class="vx-col">
        <vx-tooltip :text="`PowerBI report ${reportId} in workspace ${workspaceId}`" position="bottom">
          <feather-icon icon="InfoIcon" svg-classes="h-6 w-6" />
        </vx-tooltip>
      </div>
      <div v-if="venueFilter" class="vx-col p-0">
        <vx-tooltip
          :text="`Venue filter is enabled. Filtering at ${venueFilterTable}/${venueFilterColumn} for ${filterVenues.length} venues`"
          position="bottom">
          <feather-icon icon="LockIcon" svg-classes="h-6 w-6" />
        </vx-tooltip>
      </div>
      <div v-if="isLoading" class="vx-col flex-grow">
        <vs-progress class="w-full" indeterminate color="dark"></vs-progress>
      </div>
    </div>

    <div>
      <vs-alert v-if="pbiHasError" closable color="danger" close-icon="close">
        {{ pbiError }}
      </vs-alert>
    </div>
    <!-- <Loading v-if="isLoading" /> -->
    <div class="vs-row" id="report-wrapper">
      <!-- :class="{ hidden: !hasAppliedFilter && venueFilter }" -->
      <section id="report-container" class="embed-container"></section>
      <!-- Used to display report embed error messages -->
      <section class="error-container m-5"></section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
//import * as powerbi from 'powerbi-client';
export default {
  props: {
    reportId: String,
    workspaceId: String,
    venueFilterColumn: String,
    venueFilterTable: String,
    filterVenue: String,
    venueFilter: Boolean,
    showLoading: Boolean,
    showNavbar: Boolean,
    fitToWidth: Boolean,
    permission: String,
  },
  data() {
    return {
      isLoading: false,
      hasAppliedFilter: false,
      pbiError: "",
      pbiHasError: false,
      report: null,
    };
  },
  components: {},
  methods: {
    async loadReport() {
      this.isLoading = true;

      let reportDetails = "";
      try {
        reportDetails = await this.$store.dispatch("powerBi/getReportDetails", {
          reportId: this.reportId,
          workspaceId: this.workspaceId,
        });
      } catch (ex) {
        this.isLoading = false;
        this.pbiHasError = true;
        this.pbiError =
          "An error occured retrieving embed access token for this report. This may be due to RLS or incorrect report setup.";
        return;
      }

      //console.log("Got report details: ", reportDetails);
      let reportContainer = document.getElementById("report-container");

      //let powerbi = window["powerbi-client"];
      let models = window["powerbi-client"].models;

      //console.log("wabba", powerbi);
      powerbi.bootstrap(reportContainer, { type: "report" }); // eslint-disable-line

      const embedData = reportDetails;

      let pageSize = {
        type: models.PageSizeType.Custom,
        width: 300,
        height: 580,
      };

      // Create a config object with type of the object, Embed details and Token Type
      let reportLoadConfig = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: embedData.EmbedToken.Token,

        embedUrl: embedData.EmbedReport[0].EmbedUrl,

        // Enable this setting to remove gray shoulders from embedded report
        settings: {
          panes: {
            bookmarks: {
              visible: false,
            },
            fields: {
              expanded: false,
            },
            filters: {
              expanded: false,
              visible: false,
            },
            pageNavigation: {
              visible: this.showNavbar,
            },
            selection: {
              visible: false,
            },
            visualizations: {
              expanded: false,
            },
          },

          layoutType: models.LayoutType.Custom,
          pageSize: pageSize,
          customLayout: {
            //pageSize: pageSize,
            displayOption: this.fitToWidth ? models.DisplayOption.FitToWidth : models.DisplayOption.FitToPage,
          },
        },
      };

      //console.log("Powerbi config", reportLoadConfig);

      // Use the token expiry to regenerate Embed token for seamless end user experience
      // Refer https://aka.ms/RefreshEmbedToken
      const tokenExpiry = embedData.EmbedToken.Expiration;

      // Embed Power BI report when Access token and Embed URL are available
      this.report = powerbi.embed(reportContainer, reportLoadConfig); // eslint-disable-line

      // Clear any other loaded handler events
      this.report.off("loaded");

      // Triggers when a report schema is successfully loaded
      this.report.on("loaded", () => {
        console.log("Report load successful");
        this.applyFilter();
      });

      // Clear any other rendered handler events
      this.report.off("rendered");

      // Triggers when a report is successfully embedded in UI
      this.report.on("rendered", () => {
        this.isLoading = false;
        this.applyFilter();
        console.log("Report render successful");
        this.report.off("rendered");
      });

      // Clear any other error handler events
      this.report.off("error");

      // Handle embed errors
      this.report.on("error", (event) => {
        this.isLoading = false;
        let errorMsg = event.detail;
        this.pbiHasError = true;
        this.pbiError =
          "Error loading PowerBI report: " + errorMsg.detailedMessage;
        console.error(errorMsg);
        return;
      });
    },
    async applyFilter() {
      if (!this.venueFilter) {
        this.$vs.loading.close();
        console.log("No filter required");
        return;
      }

      let models = window["powerbi-client"].models;
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: this.venueFilterTable,
          column: this.venueFilterColumn,
        },
        operator: "In",
        values: this.filterVenues,
      };

      // console.log("Applying filters:, ", filter);

      // Add the filter to the report's filters.

      try {
        await this.report.updateFilters(models.FiltersOperations.Replace, [
          filter,
        ]); // Add
        this.hasAppliedFilter = true;
        console.log("Report filter was added.", filter);
      } catch (errors) {
        console.log(errors);
      }
      if (this.showLoading) this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters({
      venues: "venues/venues",
      reportDetails: "powerBi/reportDetails",
      venuePermissions: "venuePermissions",
    }),
    filterVenues() {
      // console.log("Filtering for venues: ", this.venues, this.venuePermissions, this.permission, this.filterVenue)
      if (this.filterVenue) return [this.filterVenue];

      if (this.permission) // If there is an idam permission to view this 
        return this.venues.map((e) => e.venueId).filter((e) => _.some(this.venuePermissions, v => v.venueId === e && (v.permissions.includes(this.permission) || v.globalPermissions.includes(this.permission))));

      return this.venues.map((e) => e.venueId);
    },
    /*filterVenuesDesc() {
      return this.venues.map(
        (e) =>
          `(${e.name}: ${
            e.isFromNewPlanday ? e.newDepartmentId : e.plandayPortalId
          })`
      );
    },*/
  },
  async created() { },
  async mounted() {
    this.report = null;
    this.loadReport();
  },
};
</script>

<style lang="scss">
hidden {
  display: none;
}

/* iframe's parent node */
.content-wrapper {
  position: relative;
  height: 1px;

  .router-view {
    height: 100%;

    .router-content {
      height: 100%;

      .content-area__content {
        height: 100%;
      }
    }
  }
}

#powerbi-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  #report-wrapper {
    position: relative;
    flex: 2;
    /* margin-bottom: 52px; */

    iframe {
      border-radius: 7px;
      box-shadow: 1px 4px 12px rgba(0, 0, 0, 0.2);
      border: 1px solid #cecece;
    }

    #report-container {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
}

/*! rtl:begin:ignore */
#powerbi-wrapper {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>